import { render, staticRenderFns } from "./SGShardedClusterOverview.vue?vue&type=template&id=79bb6734&scoped=true"
import script from "./SGShardedClusterOverview.vue?vue&type=script&lang=js"
export * from "./SGShardedClusterOverview.vue?vue&type=script&lang=js"
import style0 from "./SGShardedClusterOverview.vue?vue&type=style&index=0&id=79bb6734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb6734",
  null
  
)

export default component.exports